import { render, staticRenderFns } from "./Boleado.vue?vue&type=template&id=0d900866&scoped=true&"
import script from "./Boleado.vue?vue&type=script&lang=js&"
export * from "./Boleado.vue?vue&type=script&lang=js&"
import style0 from "./Boleado.vue?vue&type=style&index=0&id=0d900866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d900866",
  null
  
)

export default component.exports